import { useState, useEffect } from 'react';
import { versionApi } from '../services/api';
import type { VersionResponse } from '../types';

// Cache da versão para evitar múltiplas requisições
let cachedVersion: VersionResponse | null = null;

export function useVersion() {
  const [version, setVersion] = useState<VersionResponse | null>(cachedVersion);
  const [isLoading, setIsLoading] = useState(!cachedVersion);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Se já temos cache, não precisa buscar novamente
    if (cachedVersion) {
      setVersion(cachedVersion);
      setIsLoading(false);
      return;
    }

    const fetchVersion = async () => {
      try {
        const data = await versionApi.get();
        cachedVersion = data;
        setVersion(data);
      } catch (err) {
        setError('Erro ao carregar versão');
        // Em caso de erro, usa versão padrão
        const fallback: VersionResponse = {
          version: '1.0.0',
          commitHash: 'local',
          commitHashFull: 'local',
          commitDate: '',
          branch: 'local',
          buildDate: '',
          display: 'v1.0.0-local',
        };
        setVersion(fallback);
      } finally {
        setIsLoading(false);
      }
    };

    fetchVersion();
  }, []);

  return { version, isLoading, error };
}
